import { NgModule, Component, Input, Output, ChangeDetectionStrategy, ViewChild, ChangeDetectorRef, EventEmitter } from '@angular/core';
import { isPlatformBrowser, isPlatformServer, Location } from '@angular/common'
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'vdgm-date-picker',
    template:`
        <ng-container>
            <input #input [matDatepicker]="myDatepicker" [max]="maxDate" [readonly]="locked" (dateChange)="dateChanged($event)" [value]="selectedValue" >
            <!--<mat-datepicker-toggle class="picker" [for]="myDatepicker"></mat-datepicker-toggle>-->            
            <mat-datepicker #myDatepicker></mat-datepicker>
            <button class="picker" (click)="myDatepicker.open()"><i class="icon cntv-event"></i>{{input.value}}<i class="icon cntv-arrow-down"></i></button>
        </ng-container>
    `,
    styleUrls: ['vdgm-date-picker.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VdgmDatePicker {
    @Input() locked:boolean;
    @Output() onChange:EventEmitter<any> = new EventEmitter<any>();
    @Input() selectedValue = new Date();
    
    maxDate = new Date();
    /**
     * SeriesSpotlight component
     */
    constructor(private coreEffects: CoreEffects, private cd: ChangeDetectorRef, ) {
    }

    dateChanged(e:any){
        this.onChange.next(e.value)
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/series/vdgm-date-picker/vdgm-date-picker.component.ts